import Api from '@/services/api';

export default {
  getPosts() {
    return Api.get('preview-posts');
  },
};
